import Menus from './components/Menus'
import makeStyles from '@material-ui/core/styles/makeStyles'
import UserInfoCard from './components/UserInfoCard'
import MenuTopButtons from './components/MenuTopButtons'

const AdminSideMenuv2 = ({ minimizeMenu, setMinimizeMenu }) => {
  const classes = useStyles({ minimizeMenu })

  return (
    <div className={classes.root}>
      <MenuTopButtons
        minimizeMenu={minimizeMenu}
        setMinimizeMenu={setMinimizeMenu}
      />
      <Menus minimizeMenu={minimizeMenu} />
      <UserInfoCard minimizeMenu={minimizeMenu} />
    </div>
  )
}

export default AdminSideMenuv2

const useStyles = makeStyles((theme, props) => ({
  root: {
    position: 'relative',
    height: '100%',
    minHeight: 0,
    boxSizing: 'border-box',
    width: (props) => (props.minimizeMenu ? '85px' : '240px'),
    transition: 'all 0.2s ease',
    backgroundColor: theme.palette.quaternary.accent,
    overflowY: 'auto',
    overflowX: 'hidden',
    overscrollBehaviorY: 'contain',
    scrollbarGutter: 'stable',
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#9A9A9A'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: theme.palette.quaternary.accent
    },
    '&::-webkit-scrollbar': {
      width: 8
    },
    '&> *': {
      boxSizing: 'border-box'
    }
  }
}))
